import { createRoute } from "@tanstack/solid-router";
import { MODALITY_IN_PERSON_KEY } from "@space/shared";
import { appRoute } from "./route";
import { withFeatureGate } from "@/features/flags/feature-gate";
import { CheckinView } from "@/features/academy/components/checkin-view";

export const checkinRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/checkin",
  // §L1 · online-first: el pase de lista con código es PRESENCIAL. La ruta sigue
  // existiendo (no 404): muestra el estado «deshabilitada por tu academia», que
  // explica que nada se borró y que todo vuelve al re-habilitar.
  component: withFeatureGate(MODALITY_IN_PERSON_KEY, CheckinView),
});
